<main id="db-wrapper" class="bg-light">
  <app-admin-vetical-sidebar></app-admin-vetical-sidebar>
  <section id="page-content">
    <div class="header">
      <app-only-admin-navigation *ngIf="userRole=='Administrator'"></app-only-admin-navigation>
      <app-admin-nav *ngIf="userRole!='Administrator'"></app-admin-nav>
    </div>

    <div *ngIf="loading">
      <div class="container-fluid p-4">
        <div class="row">
          <div class="col-lg-12">
            <div class="border-bottom pb-4 mb-4 d-lg-flex justify-content-between align-items-center">
              <div class="mb-3 mb-lg-0">
                <h1 class="mb-0 h2 fw-bold">
                  {{'MENU.MARKET_TRENDS' | translate}}
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row d-grid">
            <button class="btn btn-primary btn-lg"> Loading... </button>
          </div>
        </div>
      </div>

    </div>
    <div *ngIf="!loading">
      <div class="container-fluid p-4">
        <div class="row">
          <div class="col-lg-12">
            <div class="border-bottom pb-4 mb-4 d-lg-flex justify-content-between align-items-center">
              <div class="mb-3 mb-lg-0">
                <h1 class="mb-0 h2 fw-bold">
                  {{'MENU.MARKET_TRENDS' | translate}}
                </h1>
                
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid mb-8">
          <app-no-content-found *ngIf="notifications.length<=0">
           </app-no-content-found>
           <p-scrollpanel [style]="{ width: '100%', height: '600px' }" >
            <div class="row align-items-center p-4" *ngIf="notifications.length>0">
         
              <div class="col-lg-12 mb-3" *ngFor="let item of notifications; trackBy: trackByNotificationId" >
              <div class="card p-4" (click)="ShowDialog(item)">
                <i>
                  📈💼🎯🤝
                </i>
                <h5 class="news-title text-dark mt-3">{{item.title}}</h5>
 
                <div class="lead text-dark truncate-html" [innerHTML]="item.sanitizedHtml"></div>

                <img *ngIf="item.imageSrc" 
                    [src]="item.imageSrc" 
                    class="img-fluid rounded-2 shadow-sm my-3"
                    style="max-width: 100%; height: auto; object-fit: cover;" />


                <div class="news-footer text-dark d-flex justify-content-between">
                  <span>{{ item.timestamp | date:'dd-MM-yy hh:mm a' }}</span>
                   
                </div>
                <button   class="text-decoration-none ms-5 mt-3 link btn btn-primary" (click)="ShowDialog(item)">{{'ReadMore' | translate}} →</button>
            </div>
      
              </div>
              <div class="col-lg-12 mb-8">
                <div class="pagination-controls text-center">
                  <button class="btn btn-secondary" (click)="goToPrev(userId)" [disabled]="!canGoPrev">Previous</button>
                  <button class="btn btn-primary ms-3" (click)="goToNext(userId)" [disabled]="!canGoNext">Next</button>
                </div>
              </div>
            </div>
           </p-scrollpanel>
          
        </div>
      </div>
    </div>


  </section>
</main>

<div class="d-block d-sm-block d-md-none d-lg-none d-xl-none mt-5">
  <app-bottom-nav></app-bottom-nav>
</div>

<p-dialog header="Detail" [modal]="true" [(visible)]="visible" 
[style]="{ width: '50rem' }" 
[breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">
  
<h2 *ngIf="SingleNotification">
  {{ SingleNotification.title }}
</h2>

<div class="mb-8" *ngIf="SingleNotification">
  <div class="lead text-dark" [innerHTML]="SingleNotification.sanitizedHtml"></div>

  <img *ngIf="SingleNotification.imageSrc"
    [src]="SingleNotification.imageSrc"
    class="img-fluid rounded-2 shadow-sm my-3"
    style="max-width: 100%; height: auto; object-fit: cover;" />
</div>
</p-dialog>
